/**
 *
 * @class {SectionUserContent.Edit}
 * @extends {SectionUserContentBase}
 */
SectionUserContent.Edit = Class(
	/**
	 * @lends {SectionUserContent.Edit#}
	 */
	{
		bodyClass: 'small-nav grey hide-tablet-footer full-container',

		route: function(){
			PARENT.route();
			let part = this.url.shift();
			if( empty(part) || isNaN(Number(part)) ){
				Section.navigate(D.url('user-content'));
				return false;
			}
			this._taskId = Number(part);
		},

		_draw: function(){
			this.rpc.send('getUserContent', {
				id: this._taskId
			}, this._onData);
		},

		_onData: function(data){
			if( data.error ){
				Section.navigate(D.url('user-content'));
				return;
			}
			new SectionUserContent.Wizard(data.task).append(this._mainContentNode);
			this.ready();
		}
	},
	SectionUserContentBase
);